import React from "react";
import { Block } from "@xprog/prensa";
import * as t from "./Article.types";

const ArticleContainer = (props: t.ContainerProps) => (
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss,
      ...(props.hideInDesktop && { "@lg": { display: "none" } }),
    }}
  >
    {props.children}
  </Block>
);

const ArticleContentLeft = (props: t.ContainerProps) => (
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss,
    }}
  >
    {props.children}
  </Block>
);

const ArticleContentRight = (props: t.ContainerProps) => (
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss,
      ...(props.hideInDesktop && { "@lg": { display: "none" } }),
    }}
  >
    {props.children}
  </Block>
);

const ArticleContent = (props: t.ContainerProps) => (
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss,
    }}
  >
    {props.children}
  </Block>
);

const ArticleTagContainer = (props: t.ContainerProps) => (
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss,
    }}
  >
    {props.children}
  </Block>
);

const ArticleShareSectionContainer = (props: t.ContainerProps) => (
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss,
    }}
  >
    {props.children}
  </Block>
);

ArticleContainer.defaultProps = {
  defaultCss: {
    align: ["row", "center", "middle"],
    width: "100%",
  },
};

ArticleContent.defaultProps = {
  defaultCss: {
    align: ["row", "center", "between"],
    width: "calc(100% - $6)",
    maxWidth: "960px",
    "@lg": {
      width: "100%",
    },
  },
};

ArticleContentLeft.defaultProps = {
  defaultCss: {
    width: "100%",
  },
};

ArticleContentRight.defaultProps = {
  defaultCss: {
    display: "none",
  },
};

ArticleTagContainer.defaultProps = {
  defaultCss: {
    align: ["row", "left", "top"],
    flexWrap: "wrap",
    my: "$0",
    mb: "$6",
    width: "calc(100% - calc($4 * 3))",
    maxWidth: "960px",
  },
};

ArticleShareSectionContainer.defaultProps = {
  defaultCss: {
    align: ["row", "left", "middle"],
    mt: "$5",
    mb: "$11",
  },
};

export {
  ArticleContainer,
  ArticleContent,
  ArticleContentLeft,
  ArticleContentRight,
  ArticleShareSectionContainer,
  ArticleTagContainer,
};
